import { defineMessages } from '@/lib/i18n';

// Keep these sorted alphabetically.

export default defineMessages({
  regulationCount: '規則{count}',
  addLaw: '該当する法令を追加',
  addPrompt: '法令の入力を行なってください',
  chapter15Data: '第15章のデータ',
  regulations: '細則',
  rescueConfirmation: '第15章のデータの削除フラグを外しますか?',
  clickDeleteFlag:
    '「削除する」をクリックすると、選択されたデータに削除フラグを付与します。',
  encsNumber: '化審法番号',
  ishlNumber: '安衛法番号',
  concentration: '含有割合・含有量・濃度',
  isStated: 'SDS記載',
  confirmRescueFlag: '削除フラグを取り消しますか?',
  subjectConfirmRescueFlag: 'を削除フラグを取り消しますか?',
  clickRescueFlag:
    '「削除フラグを取り消す」をクリックすると、選択されたデータに削除フラグを取り消します。',
  rescueFlag: '削除フラグを取り消す',
  enterData: 'データを入力してください',
  encsNumberForm:
    '官報公示番号・官報公示番号（化審法）・化審法番号 / ENCS Number・CSCL Number',
  ishlNumberForm:
    '官報公示番号（安衛法番号）・安衛法番号 / ISHL Number・ISHA Number',
  concentrationSecretForm: '含有量が非公開または不明の場合はチェック',
  sdsList: 'SDS一覧',
  sdsNotStatedForm: 'SDS記載なし',
  concentrationForm: '重量%・含有割合・含有量・濃度 / Concentration・Content %',
  valueForm: '値',
  minValueForm: '最小値',
  maxValueForm: '最大値',
  add: '追加',
  addAction: '追加する',
  addBoilingPoint: '沸点を追加',
  addChemical: '化学物質を追加',
  addComponentInfo: '成分情報を追加',
  addExposureLimit: '暴露限界値・許容濃度を追加',
  addFlashPoint: '引火点を追加',
  addImporterInfo: '輸入者・販売者情報を追加',
  addManufacturer: '製造者情報を追加',
  addPhysicalChemicalProperties: '物理的・化学的性質を追加',
  address: '住所',
  addressLong: '住所 / Address',
  addTagName: 'タグを作成',
  aliases: '別名',
  alreadyExistingTags: '行 {row}: このタグはすでに登録されています。',
  analysis_status: 'データ化ステータス',
  analaysisResultEmail: '分析結果メール',
  analyzing: 'データ化中',
  and: '及び',
  applicable: '該当する',
  applicableCategory: '該当区分',
  notApplicable: '該当しない（非該当）',
  unclear: '該非不明確',
  notStated: '該非記載なし',
  applied: '追加済み',
  apply: '適用する',
  assignee: '担当ユーザー',
  back: '戻る',
  bulkEdit: '一括編集',
  bulkOperations: '一括操作',
  bulkEditWithCsv: 'CSVファイルでの一括編集',
  bulkEditWithCsvUploadLimitCount:
    '※一括編集できるSDSのファイル数は10,000件が上限です。',
  bulkEditWithCsvDownloadCsvFile:
    '選択中のSDSから一括編集用のCSVファイルをダウンロードする',
  bulkRiskReassessment: '一括リスク再評価',
  bulkRiskReassessmentUploadLimitCount:
    '※一括再評価できるSDSのファイル数は10,000件が上限です。',
  bulkRiskReassessmentDownloadCsvFile:
    '選択中のSDSからリスク再評価用のCSVファイルをダウンロードする',
  cancel: 'キャンセル',
  casNumber: 'CAS番号',
  commentFromChemican: 'ケミカンからのコメント',
  casNumberLong: 'CAS番号 / CAS Number・CAS RN',
  category: '区分',
  categoryDustRespirable: '吸引性区分',
  cause: '要因',
  cautionExportDate:
    'こちらで指定できる時間は、エクスポート処理の開始時間です。時刻は日本時間(JST)として扱われます。',
  cautionExportTiming:
    '実際にエクスポートファイルのリンクがメールで送信されるのは、処理がすべて完了した後になります。',
  cautionMacCc: '最大10名まで',
  change: '変更する',
  checkFrequency: 'チェックは1日1回、深夜に行われます。',
  considerThreshold:
    '考慮する（ただし、含有率が未記載のデータはCAS番号または物質名が合致すれば抽出対象となります）',
  checklist: 'チェックリスト',
  checklistAddDate: 'チェックリスト追加日',
  checklistCompletionStatus:
    'リストチェック完了：{lastCount}件/{uploadedTotal}件、次回更新日時：{nextUpdateDate}',
  checklistNotifyPreference: 'チェックリスト更新通知メールの配信希望',
  favoriteChecklist: 'お気に入り',
  favoriteAdd: 'お気に入りに登録',
  favoriteRemove: 'お気に入りを解除',
  favoriteRemoveSuccess: 'お気に入りを解除しました',
  favoriteMailSettingsLink: 'メール受信設定',
  undo: '元に戻す',
  favoriteAddConfirmTitle: 'お気に入りに登録しますか？',
  favoriteAddConfirmBody:
    'お気に入りに登録すると、対象のチェックリストに変化があった際にメールでお知らせします。いつでも解除できます。',
  favoriteAddConfirmMailNote: 'メール通知の受信は、マイページの',
  favoriteAddConfirmMailNoteSuffix: 'からいつでも停止できます。',
  favoriteRemoveConfirmTitle: 'お気に入りを解除しますか？',
  favoriteRemoveConfirmBody:
    'お気に入りを解除すると、変化のお知らせメールは届かなくなります。',
  chemical: '化学物質',
  chemicalName: '化学物質名 / Chemical Name',
  chemicalProperties: '化学特性',
  chemican: 'ケミカン',
  clearFilters: 'フィルターをクリアする',
  clearSelection: '選択解除',
  close: '閉じる',
  color: 'カラー',
  company: '運営会社',
  companyIdentification: '社名 / Company Name・Company Identification',
  companyName: 'テナント名',
  confirmDelete: '本当に削除しますか',
  confirm: '確認',
  confirmLeave: '編集中の作業は保存されませんが、よろしいですか？',
  contactPhoneNumber: '連絡先電話番号',
  contactUs: 'お問い合わせ',
  copy: 'コピー',
  create: '作成する',
  createDepartment: '部署を作成する',
  createDepartmentTitle: '部署を作成',
  createDepartmentTooltip: '新しく部署を作成します',
  createFromLaws: '法令から作成する',
  createFromMaterials: '物質から作成する',
  creationDate: '作成日',
  creator: '作成者',
  scimOperationNotAllowed:
    'SCIMが有効化されているため、こちらの操作はできません',
  csvDownload: 'CSVダウンロード',
  csvUpload: 'CSVアップロード',
  csvDownloadDepartments: '部署一覧をCSVファイルでダウンロードします',
  csvUploadDepartments:
    'CSVファイルから部署の一括登録・名称変更・階層移動を行います',
  csvDownloadUsers: '同じ企業の全ユーザーをCSVファイルでダウンロードします',
  csvUploadUsers: 'CSVファイルをアップロードしてユーザーを追加、更新します',
  csvDownloading: 'CSV をダウンロードしています...',
  csvDownloadSuccess: 'CSVファイルをダウンロードしました',
  csvDownloadFailed: 'CSVダウンロードに失敗しました',
  csvUploadSuccess: 'CSVアップロードが完了しました',
  csvUploadFailed: 'CSVアップロードに失敗しました',
  csvFileRequired: 'CSVファイルを選択してください',
  csvFileNeedUpdate: 'このCSVファイルは修正が必要です。',
  csvFileHasError: 'CSVファイルにエラーがあります。',
  csvFileUploadAgain: 'CSVファイルを修正し、再度アップロードしてください。',
  csvDepartmentRegistered: '{count}件の部署を登録しました。',
  csvDepartmentUpdated: '{count}件の部署を更新しました。',
  csvDepartmentUpdatedAndRegistered:
    '{count_created}件の部署を登録しました。\n{count_updated}件の部署を更新しました。',
  csvHandleFinish: 'アップロード完了',
  csvHandleLoading: 'アップロード中......',
  csvFileUploadFailed: 'アップロード失敗',
  currentIpAddresses: '現在経由しているIPアドレス',
  csvTagBulkMissingQuotes: 'ダブルクォートが閉じられていません',
  csvTagBulkTooManyFields:
    '「現在のタグ名」と「新しいタグ名」の2列で記載してください',
  currentSearchCriteria: '現在の検索条件',
  custom: 'カスタム',
  dbtTypeCas: '3章：物質のCAS番号',
  dbtTypeMaterial: '3章：物質の名称',
  dbtTypeOutdated: 'SDS改訂日：5年以上経過',
  dbtTypeRegulation: '15章：製品に該当する規則',
  dataFormatCustomization: 'データ形式カスタマイズ',
  dataToDelete: '削除するデータ',
  dataToRescue: '削除フラグを取り消しするデータ',
  date: '日付',
  default: '標準',
  defaultUser: 'ケミカン運営',
  delete: '削除',
  deleteAction: '削除する',
  deleteClientIpAlert: '自身のIPアドレスの削除は最後に行うようにしてください。',
  deleteThisIpAddress: 'このIPアドレスを削除',
  deleteDepartment: 'この部署を削除します',
  deletedChip: '削除済み',
  deletedSdsWarning: 'ユーザー側で削除済みのSDS',
  deleteInstruction:
    '「削除する」をクリックすると、データに削除フラグが付与されます。付与された削除フラグは、画面上部の「保存」をクリックすることでデータベースに反映されます。',
  deletePeriodicExportSetting: '定期エクスポート設定の削除',
  deleteProduct: '製品を削除しますか',

  deleteUser: 'ユーザーを削除しますか？',
  deleteWarning:
    '「削除する」をクリックすると、データがDBから削除されます。この操作は戻すことができません。',
  department: '担当部署',
  departmentInfo:
    '追加できるのは自分が所属している部署のみです。{br}管理者はすべての部署が選択できます。',
  departmentName: '部署名',
  editDepartment: '部署の編集',
  departments: '部署',
  description: '説明',
  destinationRecipient: '宛先受信者',
  enabled: '有効',
  disabled: '無効',
  documentCounter: '{count}件',
  downloadSampleCsvFile: 'サンプルCSVファイルをダウンロードする',
  download: 'ダウンロード',
  duplicateIpAddress: '行 {row}: 重複するIPアドレスが存在します',
  duplicateMaterial:
    '同じ含有成分は{classification_system}の分類体系にすでに登録されています',
  edit: '編集',
  editImporterData: '第1章輸入者・販売者のデータを編集してください',
  editManufacturerData: '第1章製造者のデータを編集してください',
  editPeriodicExportSetting: '定期エクスポート設定の編集',
  editPrompt: '編集を行なってください',
  email: 'メールアドレス',
  emailLabel: 'メールアドレス / Email Address',
  enableSmsAuth: 'SMS認証を有効にする',
  enableTotpAuth: '認証アプリを有効にする',
  enterExposureLimit: '追加する暴露限界値を入力してください',
  equal: 'と等しい(=)',
  errorCreateFailed: 'リストの作成に失敗しました',
  extractionConditions: '抽出条件',
  featureNameCreateChecklist: 'チェックリスト作成',
  everyDay: '毎日',
  everyMonth: '毎月',
  everyWeek: '毎週',
  execute: '実行する',
  export: 'エクスポート',
  exportCharacterCode: 'エクスポート文字コード',
  exportCharacterCodeTooltip:
    'Windowsは通常Shift_JISで開けますが、特殊記号（℉、®、²など）が含まれる場合やMacではUTF-8を選んでください。詳しくは「ヘルプセンター」をご確認ください。',
  exportContents: 'エクスポート内容',
  exportContentsProductInfo: '製品名、SDS情報',
  exportContentsRiskLevel: 'リスクレベル（健康有害性、物理化学的危険性）',
  exportContentsWorkEnvironment: '作業環境の入力項目',
  exportDatePatternList: '1日,5日,10日,15日,20日,25日,末日',
  exportFormat: 'エクスポート形式',
  exportType: 'エクスポート種別',
  features: '機能',
  fileFormat: 'ファイル形式',
  fileSizeExceeded: '2MBを超えるCSVファイルはアップロードできません。',
  filter: 'フィルター',
  firstName: '名',
  formatShiftJis: 'Shift-JIS',
  paidPlan: '有料プラン',
  unlimitedPlan: '無制限プラン',
  freeTrial: '無料トライアル',
  frequency: '頻度',
  from: '開始',
  fullName: '氏名',
  genericError: 'エラーが発生しました。もう一度お試しください。',
  greaterThan: 'より大きい(>)',
  greaterThanLess: 'より大きい(>)、未満(<)',
  greaterThanLessOrEqual: 'より大きい(>)、以下(≦)',
  greaterThanOrEqual: '以上(≧)',
  greaterThanOrEqualLess: '以上(≧)、未満(<)',
  greaterThanOrEqualLessOrEqual: '以上(≧)、以下(≦)',
  hasNewerSdsRevision: 'このSDSには改訂日の新しいものが登録されています',
  ifChineseSDS: '中国語SDSは、3章までをデータ化の対象としております。',
  impurityChip: '不純物',
  incorrectPassword: 'パスワードが正しくありません',
  invalidEmail: 'メールアドレスが正しくありません。',
  invite: '招待する',
  invalidIpFormat: '行 {row}:無効なIPアドレス形式です',
  invalidNameFormat: '行: {row}:名前は空文字を除く46文字以内で入力してください',
  ipAddress: 'IPアドレス',
  ipAddressAdded: 'IPアドレスを追加しました',
  isLabelNotShown: 'ラベル表記なし',
  itemsPerPageText: '行/ページ',
  knowledgeCenter: 'ナレッジセンター',
  lastExecutionDate: '最終実行日時',
  lastName: '姓',
  lastUpdatedDate: '最終更新日',
  latestOnly: '同一判定された製品のSDSは最新版のみ表示する',
  law: '法令',
  lessThan: '未満(<)',
  lessThanOrEqual: '以下(≦)',
  listName: 'リスト名',
  login: 'ログイン',
  logoAlt: 'ケミカン - SDSを正確にデータ化',
  manufacturers: '製造者',
  match: '該当',
  beforeJudgement: '判定前',
  materialChip: '主成分',
  material: '含有成分',
  materialName: '化学物質名',
  measurementMethod: '計測方法・測定方法・方法',
  mgPerM3: 'mg/m³',
  middleName: 'ミドルネーム',
  more: '件',
  myFilter: 'マイフィルター',
  name: '名前',
  nameForManagement: '名前(管理用)',
  causeUpdated: '要因欄更新',
  newAddition: '新規追加',
  newChip: '新規',
  newSds: '新規SDS',
  newsletterPreference: '分析結果メールの配信希望',
  nextScheduleDate: '次回実行予定日時',
  noDataText: 'データが登録されていません',
  noDepartmentSDS: '部署なし',
  noLabelDataText: '{label}が見つかりませんでした。',
  noLawRegulation: '該当法令なし',
  noMatch: '非該当',
  noMatchingSds: '該当するSDSは0件です。次回の更新をお待ちください。',
  none: 'なし',
  noTag: 'タグなし',
  nonenPublic: '非公開',
  noPermission: '権限がありません。{details}',
  noTagsFound: 'タグが見つかりませんでした',
  noTagsRegisteredInfo:
    '登録されているタグがありません。{linebreak} タグの登録は、{registerLink} から行うことができます。',
  noticeEligibility:
    '2025年11月6日以降にアップロードされたSDSのみが対象となります。',
  note: 'メモ',
  ok: 'OK',
  onlyReceiveCsvFile: 'CSVファイルのみアップロード可能です。',
  operationIrreversible: 'この操作は取り消すことができません',
  other: 'その他',
  parentDepartment: '親部署',
  pageSelect: 'ページ選択',
  rowsPerPage: '表示行数',
  parentIndicator: '内訳フラグ',
  parentMaterial: '上位成分名',
  parentMaterialTooltip:
    '上位成分がある場合はこの列に\nチェックアイコンが表示されます',
  parentMaterialNameTooltip:
    '成分がさらに上位の成分の内訳で\nある場合に、上位成分の名前が記\n載されます。',
  parentMaterialDeleted: '親材料が削除されています',
  parentImpurityMaterialDeleted: '親不純物材料が削除されています',
  checkMark: '✓',
  password: 'パスワード',
  passwordConfirmation: 'パスワード(確認用)',
  passwordFormatInfo:
    '{minLength}文字以上かつ半角英大文字・半角英小文字・半角数字・記号(!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~)をそれぞれ最低1回以上使用してください',
  passwordMismatch: 'パスワードが一致しません',
  passwordReset: 'パスワードの再発行',
  passwordResetAction: 'パスワードを再発行',
  paidPlanOnly: '有料プラン限定',
  pdfDisplay: 'PDFの表示',
  pdfName: 'PDF名',
  pdfUploadDate: 'PDFアップロード日',
  periodicExportDate: '定期エクスポート日時',
  phoneLabel:
    '連絡先（電話）/ Phone・TEL・Emergency TEL(キーボード入力後、Enterキーを押すと複数の値を入力できます)',
  phoneNumber: '電話番号',
  position: '役職',
  positionOrTitle: '役職・職位（役職がない場合は「なし」と記載ください',
  ppm: 'ppm',
  present: 'あり',
  pricing: '価格',
  privacyPolicy: 'プライバシーポリシー',
  productCode: '製品コード',
  productName: '製品名',
  productNameChange: '製品名の変更(製品名を入力してください)',
  reanalysisRequest: '再データ化依頼',
  reanalysisProcessing: '再データ化中',
  requestTypeLabel: '依頼内容',
  selectRequestTypeFirst: '先に依頼内容を選択してください',
  oldSdsSectionWarning:
    '改訂日から5年経過したSDSは初回アップロード時には3章までしかデータ化されません。すべての章をデータ化するためには、再データ化依頼をおこなってください',
  referenceSdsItems: '参照するSDS項目',
  relatedLinks: '関連リンク',
  recipient: '受信者',
  recipientCc: 'CCに追加する受信者',
  recommendUpgradePlan:
    '添付ファイル件数の増枠を追加購入いただけると、ダウンロード可能になります。お求めの場合は「お問い合わせ」からご連絡ください。',
  register: '無料で試してみる',
  removeDeleteFlag: '削除フラグを外す',
  removeDeleteFlagTitle: '第8章のデータの削除フラグを外しますか',
  rescueWarning:
    '「削除フラグを外す」をクリックすると、データに付与された削除フラグが外されます。',
  resendCode: 'コードを再送信',
  responseError: 'エラーが発生しました。{detail}',
  revisionStatus: '改訂ステータス',
  riskAssessment: 'リスク評価',
  riskAssessmentDate: 'SDSリスクアセスメント実施日',
  riskAssessmentColumnTooltipPre:
    'リスク評価は上段が「健康有害性」、下段が「物理化学的危険性」を表しています。複数の製品が紐づくSDSは、最もリスクが高い製品の値を表示しています。算出条件などの詳細は「',
  riskAssessmentColumnTooltipLinkText: 'リスク評価仕様書',
  riskAssessmentColumnTooltipPost: '」をご確認ください。',
  riskAssessmentWorkingEnvRecommendation: '作業環境入力推奨',
  riskAssessmentWorkingEnvInputRecommended: '入力推奨',
  riskAssessmentWorkingEnvInputCompleted: '入力済み',
  riskAssessmentWorkingEnvInputNotRecommendedFilterOption: '−（推奨なし）',
  riskAssessmentHealthHazard: '健康有害性リスク',
  riskAssessmentPhysicalHazard: '物理化学的危険性リスク',
  riskAssessmentLevel: 'リスク{level}',
  riskAssessmentSeeAllProducts: '全{count}製品を見る',
  riskAssessmentModalTitle: 'リスク評価一覧',
  role: '権限',
  rowIndex: '{rowIndex} 行目',
  requestChecklistConsultation: 'チェックリストのテンプレート作成リクエスト',
  save: '保存する',
  scheduledExportDate: '定期エクスポートの日時',
  supplierInquiry: 'サプライヤー問い合わせ',
  // Shared across the customer サプライヤー問い合わせ list page + the SDS-detail
  // drawer button. Values MUST match — the same chip has to render the same
  // label in both places, and the CI i18n check errors on duplicate strings
  // that aren't sourced from shared-messages.
  siStatusNotObtained: '依頼済み',
  siStatusContacted: '連絡済み',
  siStatusObtained: '対応完了',
  siStatusNotApplicable: '対応不可',
  siStatusCancelled: 'キャンセル済み',
  siInquiryContent: '問い合わせ内容',
  siStatusInfoTitle: '問い合わせステータスについて',
  siNoAttachedFile: '提供ファイルはありません',
  siRequestBtn: 'サプライヤー問い合わせを依頼',
  siSubmitRequest: '依頼する',
  requester: '依頼者',
  sdsCounter: '{count}枚',
  sdsId: 'SDS ID',
  sdsName: 'SDSファイル名',
  sdsRevisedAt: 'SDS改訂日',
  sdsTagNameIsNotOver45: 'タグ名は45文字以内で入力してください。',
  sdsTotalRegistered:
    '登録されているSDS総数のうち、データ化が完了しているSDS数がチェックの対象となります。',
  section1Department: '拠点・部門',
  section8CategoryDust: '粉塵の区分',
  section8CategoryDustRoute: '経路',
  section8CategoryMeasurement: '計測区分',
  section8CategoryTerm: '期間',
  section8CategoryUser: '対象者',
  section8FormAllowedConcentrationPPM: '許容濃度(ppm)',
  section8FormAllowedConcentrationMG: '許容濃度(mg/m³)',
  section8FormCategory: '区分 / Category',
  section8FormCategoryConcentration: '区分 / Class',
  section8FormCategoryDust: '粉塵の区分 / Dust Class',
  section8FormCategoryDustRoute: '経路 / Path',
  section8FormCategoryMeasurement: '計測区分 / Measurement',
  section8FormCategoryTerm: '期間 / Term',
  section8FormCategoryUser: '対象者 / Concerned',
  section8FormProperty: '性状 / Property',
  section8Property: '性状',
  search: '検索する',
  send: '送信する',
  searchResultsCount: '検索結果 : {count}{items}',
  searchAssigneeUsers: '担当ユーザーを検索',
  searchDepartment: '部署を検索',
  searchPlaceholder: '{label}を検索',
  searchTags: 'タグを検索',
  selectionHint:
    '選択肢の中から選択または文字入力のどちらかを選んでEnterキーを押してください',
  selectPlease: '選択してください',
  configuredSamlAuthentication: '設定済みのSAML認証',
  sdsDataSpecification: 'SDSデータ化規則',
  skinProtection: '皮膚の保護具',
  skinProtectionRequired: 'あり　',
  status: 'ステータス',
  statusCreated: '作成済み',
  statusInPreparation: '作成中',
  statusRunning: '稼働中',
  statusBeforeStart: '稼働開始前',
  statusStopped: '稼働停止',
  statusUpdateSuspended: '更新中止',
  subjectDeleteConfirmation: '{subject}を削除しますか?',
  subjectDeleted: '{subject}を削除しました',
  subscribe: '配信する',
  successfullyCsvBulkUpload: '{count}件のIPアドレスを登録しました。',
  summary: '概要',
  supplierConfirmedAt: 'サプライヤーへの確認日',
  supportedLawsList: 'データ化対象法令リスト',
  synonyms: '化学名又は一般名',
  tag: 'タグ',
  tagListLink: 'タグ一覧',
  tagName: 'タグ名',
  tagCsvCurrentTagNotFound: '行 {row}: タグ「{tagName}」は存在しません。',
  tagCsvDuplicateNewTag: '行 {row}: 新しいタグ名が重複しています。',
  tagCsvNewTagNameEmpty: '行 {row}: 新しいタグ名を入力してください。',
  tagCsvNoChanges: 'タグの変更がありません。',
  tagCsvTagNameTooLong: '行 {row}: タグ名は45文字以内で入力してください。',
  tagCsvWrongTagType: '行 {row}: タグ名の形式が正しくありません。',
  tagsBulkUpload: '{count}件のタグを追加・更新しました。',
  targetLawRegulation: '対象法令 / 細則',
  targetLaws: '対象法令',
  targetRegulations: '対象規則',
  targetSDS: '対象SDS',
  tenant: '所属テナント',
  termsOfService: '利用規約',
  thresholdConsideration: '法令データベースの閾値について',
  time: '時間',
  tfaCompleted: '二要素認証の設定が完了しました',
  tfaInvalidCode: '無効なコードです。もう一度お試しください',
  totalItems: '全{total}件',
  twoFactorAuthentication: '二要素認証',
  lastLoginAt: '最終ログイン日時',
  unit: '単位',
  unlimited: '上限なし',
  unNumber: 'UN番号',
  unsubscribe: '配信しない',
  until: '終了',
  update: '更新する',
  updateTag: 'タグを更新する',
  uploadCsvFile: 'ファイルを追加',
  uploadUser: 'アップロードユーザー',
  usageGuide: 'ヘルプセンター',
  userRegisteredAt: '登録日',
  useTotp: '認証アプリを使う',
  valuesBetweenExclusive:
    '{minValue}{unit}より大きい(>), {maxValue}{unit}以下(≦)',
  valuesBetweenExclusiveExclusive:
    '{minValue}{unit}より大きい(>), {maxValue}{unit}未満(<)',
  valuesBetweenExclusiveInclusive:
    '{minValue}{unit}以上(≧), {maxValue}{unit}未満(<)',
  valuesBetweenInclusive: '{minValue}{unit}以上(≧), {maxValue}{unit}以下(≦)',
  valuesEqual: '{value}{unit}と等しい(=)',
  valuesGreaterThan: '{value}{unit}より大きい(>)',
  valuesGreaterThanOrEqual: '{value}{unit}以上(≧)',
  valuesLessThan: '{value}{unit}未満(<)',
  valuesLessThanOrEqual: '{value}{unit}以下(≦)',
  weekday: '曜日',
  weekdayFullSundayToSaturday:
    '日曜日,月曜日,火曜日,水曜日,木曜日,金曜日,土曜日',
  weekdayShortSundayToSaturday: '日,月,火,水,木,金,土',
  whitelistIpAddress: 'ホワイトリストIPアドレス',
  addWhitelistIpAddress: 'ホワイトリストIPの追加',
  whitelistBulkRegisterCsv: 'CSVファイルでの一括登録',
  planNotAllow:
    '有償プラン契約のお客様のみご利用になれる機能です。お求めの場合は「お問い合わせ」からご連絡ください。',
  bulkEditProcessModalBodySText:
    '処理が完了しましたら、メールにてお知らせいたしますので今しばらくお待ちください。',
  bulkEditProcessModalBodyTText:
    '※大量のデータを処理する場合、完了までにお時間を要することがございます。',
  bulkEditProcessModalBodyLText:
    '※このウィンドウを閉じても処理は継続されます。',
  numberYears: '{year}年',

  verifyingAccount: 'アカウントを確認しますので、しばらくお待ちください。',
  codeResent: 'コードが再送信されました。',
  resendWait: '再送信まで {seconds} 秒',
  useSmsCode: 'SMSコードを使う',
  lostAccessToDevice: 'デバイスへのアクセスを失いましたか？',
  useBackupCode: 'リカバリーコードを使う',
  goBackToNormalTfa: '通常の二要素認証に戻る',
  productRecommendedUse: '推奨用途',
  productRestriction: '使用上の制限',
  productRecommendedUseRestriction: '推奨用途及び使用上の制限',
  jitProvisioning: 'ユーザーの自動作成 (JIT プロビジョニング)',
  samlLogin: 'SAML SSOでログイン',
  signalWords: '注意喚起語',
  invalidClerkAccountStatus:
    'SAMLログインに失敗しました。お手数ですが、ケミカンの営業担当者にお問い合わせのほど、よろしくお願い致します。',
  classificationSystem: '分類体系',
  notes: '備考',
  exportFileFormatExcel: 'Excel',
  exportFileFormatCsv: '標準CSV',
  exportFileFormatCreateSimple: '標準CREATE SIMPLE 製品DB CSV',
  exportFileFormatAllChapters: 'AI全章テキスト抽出CSV',
  exportFormatCsvChemical: '化学物質単位',
  exportFormatCsvProduct: '製品単位',
  exportFormatCsvSds: 'SDS単位',
});
